import ElectricalInstallationCertificateForm from './ElectricalInstallationCertificateForm';
import ElectricalInstallationCertificatePDF from './ElectricalInstallationCertificatePDF';
import schema from './schema';
import validator from './validator';
import defaultData from './defaultData';
import { transformForPDF } from './transform';

export default {
  Form: ElectricalInstallationCertificateForm,
  PDF: ElectricalInstallationCertificatePDF,
  schema,
  validator,
  defaultData,
  transform: transformForPDF
};